(function () {
  'use strict';
  function initBookATrip() {
    var tabs = Array.from(document.querySelectorAll('[data-bat-tab]'));
    if (!tabs.length) return;
    var panels = {
      stays: document.getElementById('bat-panel-stays'),
      flights: document.getElementById('bat-panel-flights'),
      rentals: document.getElementById('bat-panel-rentals')
    };
    function activate(which, focus) {
      if (!panels[which]) return;
      tabs.forEach(function (tab) {
        var selected = tab.dataset.batTab === which;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        if (focus && selected) tab.focus();
      });
      Object.keys(panels).forEach(function (name) { panels[name].hidden = which !== name; });
      var widgetHost = panels[which].querySelector('[data-bat-flight-widget], [data-bat-hotel-widget], [data-bat-rental-widget]');
      if (widgetHost && !widgetHost.dataset.batWidgetLoaded) {
        var raw = widgetHost.dataset.batFlightScriptUrl || widgetHost.dataset.batHotelScriptUrl || widgetHost.dataset.batRentalScriptUrl;
        var url;
        try { url = new URL(raw); } catch (_) { url = null; }
        var allowedHosts = ['tpwdg.com', 'tp.media', 'travelpayouts.com', 'tpwgts.com'];
        var trusted = url && allowedHosts.some(function (domain) {
          return url.hostname === domain || url.hostname.endsWith('.' + domain);
        });
        if (url && url.protocol === 'https:' && trusted) {
          widgetHost.dataset.batWidgetLoaded = 'yes';
          var partnerScript = document.createElement('script');
          partnerScript.async = true;
          partnerScript.charset = 'utf-8';
          partnerScript.src = url.href;
          partnerScript.addEventListener('error', function () {
            widgetHost.textContent = 'Search could not load. Please refresh the page or try again later.';
            widgetHost.setAttribute('role', 'status');
            delete widgetHost.dataset.batWidgetLoaded;
          });
          widgetHost.appendChild(partnerScript);
        } else {
          widgetHost.textContent = 'Search is currently unavailable. Please try again later.';
          widgetHost.setAttribute('role', 'status');
        }
      }
      if (which === 'flights') {
        var widget = panels.flights.querySelector('.bat-tp-container');
        if (widget && widget.dataset.wlId && widget.dataset.loaded !== 'yes') {
          widget.dataset.loaded = 'yes';
          var script = document.createElement('script');
          script.async = true;
          script.type = 'module';
          script.src = 'https://tpwgts.com/wl_web/main.js?wl_id=' + encodeURIComponent(widget.dataset.wlId);
          document.head.appendChild(script);
        }
      }
    }
        tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activate(tab.dataset.batTab, false); });
      tab.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          var next = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          activate(tabs[next].dataset.batTab, true);
        }
      });
    });
    function checkHash() {
      if (location.hash === '#flights') activate('flights', false);
      else if (location.hash === '#rentals') activate('rentals', false);
      else if (location.hash === '#hotels') activate('stays', false);
      else activate('stays', false);
    }
    checkHash();
    window.addEventListener('hashchange', checkHash);
    var form = document.getElementById('bat-flight-form');
    if (!form) return;
    var from = document.getElementById('bat-flight-from');
    var to = document.getElementById('bat-flight-to');
    var departure = document.getElementById('bat-flight-date');
    var returning = document.getElementById('bat-flight-return');
    var returnWrap = document.getElementById('bat-return-wrap');
    var adults = document.getElementById('bat-flight-adults');
    var query = document.getElementById('bat-flight-query');
    var today = new Date();
    var yyyy = today.getFullYear();
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var dd = String(today.getDate()).padStart(2, '0');
    departure.min = yyyy + '-' + mm + '-' + dd;
    returning.min = departure.min;
    function updateType() {
      var oneway = form.querySelector('input[name="trip_type"]:checked').value === 'oneway';
      returning.disabled = oneway;
      returning.required = !oneway;
      returnWrap.hidden = oneway;
    }
    form.querySelectorAll('input[name="trip_type"]').forEach(function (input) { input.addEventListener('change', updateType); });
    departure.addEventListener('change', function () {
      returning.min = departure.value || departure.min;
      if (returning.value && returning.value < returning.min) returning.value = '';
    });
    updateType();
    form.addEventListener('submit', function (event) {
      if (!form.reportValidity()) { event.preventDefault(); return; }
      var origin = from.value.trim();
      var destination = to.value.trim();
      if (origin.toLowerCase() === destination.toLowerCase()) {
        event.preventDefault();
        to.setCustomValidity('Choose a different arrival destination.');
        to.reportValidity();
        return;
      }
      to.setCustomValidity('');
      var isOneWay = form.querySelector('input[name="trip_type"]:checked').value === 'oneway';
      var result = 'Flights from ' + origin + ' to ' + destination + ' on ' + departure.value;
      result += isOneWay ? ' one way' : ' returning ' + returning.value;
      result += ' for ' + adults.value + (adults.value === '1' ? ' adult' : ' adults');
      query.value = result;
    });
    to.addEventListener('input', function () { to.setCustomValidity(''); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBookATrip);
  else initBookATrip();
})();